export default __webpack_public_path__ + "static/media/video-img.78d0a0ee.png";